module.exports = __webpack_public_path__ + "static/img/465_phase_function_Paper_Points.f971f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/465_phase_function_Paper_Points.png
// module id = Ozza
// module chunks = 0